import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleExclamationIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00034C14.1663 4.59469 11.4059 1.83352 8.00033 1.83334C4.59457 1.83334 1.83334 4.59458 1.83334 8.00034C1.83351 11.4059 4.59468 14.1664 8.00033 14.1664C11.4058 14.1662 14.1662 11.4058 14.1663 8.00034ZM15.1663 8.00034C15.1662 11.9581 11.9581 15.1662 8.00033 15.1664C4.0424 15.1664 0.833512 11.9582 0.833336 8.00034C0.833336 4.04229 4.04229 0.833344 8.00033 0.833344C11.9582 0.833519 15.1663 4.0424 15.1663 8.00034Z"
      fill="currentColor"
    />
    <path
      d="M7.5 8.00034V5.33334C7.5 5.0572 7.72386 4.83334 8 4.83334C8.27614 4.83334 8.5 5.0572 8.5 5.33334V8.00034C8.49982 8.27633 8.27603 8.50034 8 8.50034C7.72397 8.50034 7.50018 8.27633 7.5 8.00034Z"
      fill="currentColor"
    />
    <path
      d="M8.00684 10.1667C8.2829 10.1667 8.50684 10.3906 8.50684 10.6667C8.50684 10.9427 8.2829 11.1666 8.00684 11.1667H8C7.72386 11.1667 7.5 10.9428 7.5 10.6667C7.5 10.3905 7.72386 10.1667 8 10.1667H8.00684Z"
      fill="currentColor"
    />
  </svg>
);
